<div class="app-shell">
  <a class="app-shell__skip-link" href="#main-content">{{ 'layout.skipToMain' | translate }}</a>

  <div class="app-shell__page">
    <app-shell-header
      [navItems]="headerNavItems()"
      [languageLabel]="languageToggleLabel()"
      (languageToggle)="toggleLanguage()"
      (logOut)="onLogOut()"
    />

    <div class="app-shell__body">
      <app-shell-sidebar [items]="sidebarNavItems()" (itemClick)="onSidebarItemClick($event)" />

      <main id="main-content" class="app-shell__main">
        @if (shellBannersVisible()) {
          <app-shell-hero />

          @if (maintenanceBanner(); as banner) {
            <app-shell-system-alert
              [visible]="alertVisible()"
              [banner]="banner"
              (dismissed)="dismissAlert()"
            />
          }
        }

        @if (couponBannerVisible()) {
          <app-shell-coupon-banner [visible]="couponBannerVisible()" />
        }

        <app-shell-page-content />
      </main>
    </div>
  </div>
  <app-shell-footer
    #footerRef
    [legalLinks]="footerLinks()"
    [copyrightText]="footerCopyright()"
    [language]="footerLanguage()"
    [languages]="footerLanguages"
    (languageChange)="onFooterLanguageChange($event)"
  />
  <app-shell-support-chat [style.--chat-lift]="chatLift() + 'px'" />
</div>

<app-logout-confirmation-dialog
  [open]="logoutConfirmOpen()"
  (cancelled)="onLogoutConfirmCancelled()"
  (confirmed)="onLogoutConfirmed()"
/>
